$(function () {
    var topDescrSwiper = new Swiper('.numbers-0800-page .top-section .swiper-container', {
        loop: true,
        slidesPerView: 3,
        // Responsive breakpoints
        breakpoints: {
            // when window width is <=
            767: {
                slidesPerView: 1,
            },
        },
        spaceBetween: 30,
        nextButton: '.numbers-0800-top-section .swiper-button-next',
        prevButton: '.numbers-0800-top-section .swiper-button-prev',
        grabCursor: true,
    });

    var pricingSwiper = new Swiper('.numbers-0800-page .call-rates-section .swiper-container', {
        slidesPerView: 'auto',
        // Responsive breakpoints
        breakpoints: {
            // when window width is <=
            991: {
                centeredSlides: true,
                initialSlide: 1,
                spaceBetween: 30,
            },
        },
        nextButton: '.numbers-0800-page .call-rates-section .swiper-button-next',
        prevButton: '.numbers-0800-page .call-rates-section .swiper-button-prev',
        grabCursor: true
    });

    $(window).on('windowResizeBreakpointChanged', function () {
        topDescrSwiper.update();
        topDescrSwiper.slideTo(0, 0);

        pricingSwiper.update();
    });
});